import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import AccountMenu from './AccountMenu'

interface LayoutProps {
  children: React.ReactNode
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { t } = useTranslation()

  return (
    <div className="layout">
      <a href="#main-content" className="skip-link">
        {t('skipToMainContent')}
      </a>
      <header className="header">
        <div className="container">
          <div className="header-content">
            <div className="logo-section">
              <Link to="/" className="logo-link">
                <img src="/logo.svg" alt="SmartEDA" className="logo" />
              </Link>
            </div>
            <div className="center-section">
            </div>
            <div className="user-info">
              <AccountMenu />
            </div>
          </div>
        </div>
      </header>
      <main id="main-content" className="main">
        <div className="container">
          {children}
        </div>
      </main>
    </div>
  )
}

export default Layout
